import { Component, OnInit, SecurityContext } from '@angular/core';
import { DocumentViewer, DocumentViewerOptions } from '@ionic-native/document-viewer/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { File } from '@ionic-native/file/ngx';
import { FileTransfer } from '@ionic-native/file-transfer/ngx';
import { LoadingController, AlertController, NavController, Platform, MenuController, NavParams } from '@ionic/angular';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { GscService } from '../services/gsc/gsc.service';

@Component({
  selector: 'app-abstracts',
  templateUrl: './abstracts.page.html',
  styleUrls: ['./abstracts.page.scss'],
})
export class AbstractsPage implements OnInit {
  conferenceAbstracts = [
    {
    downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_Cherkashov_VNIIO_062219_JRH.pdf?alt=media&token=72dd94d8-3ea0-4640-a7e5-a379a230a2ad',
    localUrl:'Final_Cherkashov_VNIIO_062219_JRH',
    title:"Morphology and formation of SMS deposits in different geological settings",
    author: 'Georgy Cherkashov', 
    organization: 'Institute for Geology and Mineral Resources of the Ocean (VNIIOkeangeologia, St. Petersburg, Russia)', 
    },
   
   {
    downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_Chopra_SeaTech_051319.pdf?alt=media&token=f254c787-0a82-45b5-a241-bad80e40d42a',
    localUrl:'Final_Chopra_SeaTech_051319',
    title:"Designing Logistic System for Deep Sea Mining",
    author: 'Govinder Singh Chopra', 
    organization: 'SeaTech Solutions International (S) Pte Ltd. ', 
   },
  
   {
   downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_Devine_Fugro_052919.pdf?alt=media&token=665c210b-0ac2-499e-92e8-535f09860365',
   localUrl:'Final_Chopra_SeaTech_051319',
   title:"Polymetallic Nodule Abundance Estimations based on High-Resolution AUV Data and Seabed Samples for DeepGreen’s NORI Area D, Clarion Clipperton Zone",
   author: 'Christine Devine', 
   organization: 'Fugro', 
  },
   
   {
    downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_Ermakova_VNIIO_053119.pdf?alt=media&token=d4cc32cd-99c1-42bf-8a4c-c7e45bec5da9',
    localUrl:'Final_Ermakova_VNIIO_053119',
    title:"APEIs:  Some thoughts about designation for crusts and sulphides",
    author: 'Livia Ermakova', 
    organization: 'Institute for Geology and Mineral Resources of the Ocean', 
   
   },
   
   {
   downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_Freitag_BGR_053119.pdf?alt=media&token=76dec849-a733-4097-ae73-e41b6498acb9',
   localUrl:'Final_Freitag_BGR_053119',
   title:"HOMESIDE – An Advanced Tool for Hydrothermal Plume Hunting and Polymetallic Sulphide Exploration in the Indian Ocean",
   author: 'Ralf Freitag', 
   organization: 'Federal Institue for Geosciences and Natural Resources BGR', 
  },
   
   {
   downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_Gartman_USGS_053119.pdf?alt=media&token=b8f33844-a80a-4e93-9123-7948a535461d',
   localUrl:'Final_Gartman_USGS_053119',
   title:"Seafloor sulfide mineral deposition and remobilization",
   author: 'Amy Gartman', 
   organization: 'USGS Pacific Coastal and Marine Science Center', 
  },
   
   {
    downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_Helmons_TU-Delft_1_053019.pdf?alt=media&token=93baab8c-e503-474a-a53d-16733819e1c2',
    localUrl:'',
    title:"Development and Testing of a Hydraulic Nodule Collector while minimizing its Environmental Impact, Preliminary Results of Discharge Experiments (Blue Harvesting project)",
    author: 'Rudy Helmons',
    organization: 'Delft University',
   },
   
   {
    downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_Jauhari_ISA_053119.pdf?alt=media&token=a33e4eaf-3211-49dc-a7a8-01f6c6124752',
    localUrl:'Final_Jauhari_ISA_053119',
    title:"Sustainable development of Mineral Resources in the Area",
    author: 'Pratima Jauhari ',
    organization: 'National Institute of Oceanography (NIO)',
  },
   
   { 
    downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_Kaede_Kanzlei_062319.pdf?alt=media&token=924a25a2-892e-4851-84d8-c1cfc17b7eb9',
    localUrl:'Final_Kaede_Kanzlei_062319',
    title:"Can Patents be considered part of the Common Heritage of Mankind?",
    author: 'Andreas Kaede',
    organization: 'Stuttgart bar association, the Licensing Executives Society (LES), the German-American Lawyers’ Association (DAJV), and the World Ocean Council (WOC)',
   },
   
   { 
    downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_Kapusiniak_Silva_SMD_041919.pdf?alt=media&token=52bc8235-a7e1-4f37-9f97-e1190243fa3b',
    localUrl:'Final_Kapusiniak_Silva_SMD_041919',
    title:"An economically and environmentally viable underwater mining solution",
    author: 'Stef Kapusniak',
    organization: 'Mining with Specialist Machine Developments Ltd (SMD)',
   },
   
   { 
    downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_Li_Xy_COMRA_060619.pdf?alt=media&token=730f406d-cdf9-4aeb-bcfd-aab82df5bf30',
    localUrl:'Final_Li_Xy_COMRA_060619',
    title:"Progress of Chinese 100m Deep Seabed Nodule Mining Test Project",
    author: 'Li Xiangyang', 
    organization: 'National Key R&D Programme',
   },
   
   {
    downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_Munoz-Royo_MIT_053119.pdf?alt=media&token=55cf7dd9-d708-46ad-b1d1-8e64834b44a8',
    localUrl:'',
    title:"Investigating Midwater Discharge Sediment Plumes Associated with Deep-Sea Nodule Mining",
    author: 'Carlos Munoz-Royo',
    organization: 'Massachusetts Institute of Technology (MIT)',
   },
   
   {
    downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_Murton_NOC_053119.pdf?alt=media&token=e1b506a4-f595-433e-8791-5fae76bcb5ad',
    localUrl:'',
    title:"Assessing Hydrothermally Extinct Seafloor Massive Sulphide Deposits (eSMS): Lessons from the Blue Mining Project, Mid-Atlantic Ridge",
    author: 'Prof. Bramley Murton', 
    organization: 'National Oceanography Centre in Southampton', 
   },
   
   {
    downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_Lv_Shen_IDSSE_062219_JRH.pdf?alt=media&token=ada560bf-cfba-4039-bd6e-edff8d7dbf7b',
    localUrl:'',
    title:"Underwater acoustic positioning and navigation system",
    author: 'Shen Binjian', 
    organization: 'Institute of Deep-sea Science and Engineering', 
    },
   
   {
    downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_Hong_KRISO_053119.pdf?alt=media&token=67ac199f-708d-494d-bbb3-835861467981',
    localUrl:'Final_Hong_KRISO_053119',
    title:"Hazards and Risks in Deep-Seabed Mining", 
    author: 'Sup Hong', 
    organization: 'Korea Research Institute of Ships and Ocean Engineering (KRISO)', 
   },
   
   {
    downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_Suzuki_JAMSTEC_Rev_062019.pdf?alt=media&token=9126b839-0b07-427a-be9d-69de8f02322b',
    localUrl:'',
    title:"Geochemical and microbial characteristics of ferro-manganese crusts at depths ranging from 1100m to 5500m on the seamount in the northwestern Pacific",
    author: 'Katsuhiko Suzuki', 
    organization: 'Submarine Resources Research Center', 
   },
   
   {
    downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_Usui_KochiU_062219_JRH_km.pdf?alt=media&token=afc74c54-d96e-4678-a32d-472a070247e9',
    localUrl:'',
    title:"Geological characterization of cobalt-rich ferrommanganese crusts using deep-sea drill cores in the NW Pacific seamounts ",
    author: 'Akira Usui',
    organization: 'Kochi University, Japan',
   },
   
    {downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_Breschkin_ERIAS_091019.pdf?alt=media&token=3a7bc78d-fa3b-4f5b-bf04-de0c73a828f0',
    localUrl:'Final_Breschkin_ERIAS_091019',
    title:"Promoting Cost-Effective Capture of Quality Environmental Data from the Outset through Integration: A Focus on the CCZ",
    author: 'Michael Wright',
    organization: 'ERIAS Group'},
   
    {
    downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_Xu_Lixin_CMHK_061519.pdf?alt=media&token=09a8d268-4833-47d4-af08-4d25abc41310',
    localUrl:'',
    title:"Overview of a Pilot Study for Seabed Cobalt Mining",
    author: 'Xu Lixin',
    organization: 'China Merchant Offshore Technology Research Center',
   },
    
    {
    downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_Lipman-Yu_ABS_052819.pdf?alt=media&token=9716d374-feb7-4132-885d-1a1682533d41',
    localUrl:'Final_Lipman-Yu_ABS_052819',
    title:"Design Challenges of Riser & Lifting System",
    author: 'Chenteh Alan Yu',
    organization: 'Subsea Global Offshore',
   },
   
   {
    downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_Zhang_SJTU_052719.pdf?alt=media&token=b888c50b-f225-446a-a3a2-10c8e2ce1de8',
    localUrl:'',
    title:"An Unfinished Work: The Emerging Chinese Legal Regime and Management System of International Deep Seabed Mining",
    author: 'Guobin Zhang',
    organization: 'Koguan School of Law ',
    },
   
    {
    downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_Zhao_ShanghaiJiao_062319_JRH_km.pdf?alt=media&token=8618e4ab-56b0-4d85-8793-75b371d1e573',
    localUrl:'',
    title:"Research on Nodules Collecting in Deep-sea Mining: an Efficient and Environmentally Friendly Technology in Hydraulic Collecting",
    author: 'Zhao Guocheng',
    organization: 'Shanghai Jiao Tong University',
    },
   
    {
    downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_ZhengW_CMHK_062219_JRH.pdf?alt=media&token=5bcba548-9130-4244-8e10-9fd4ea6f7d6d',
    localUrl:'',
    title:"Field Planning & Seafloor Production Tool Concept Review",
    author: 'Zheng Wilson',
    organization: 'CM-OTRC',
    },
   
   {
    downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_ZhouJ_CMCORC_062319.pdf?alt=media&token=b62295a3-c2f8-4788-a669-9149128ac653',
    localUrl:'',
    title:"Surface Support System Selection for Deepsea",
    author: 'Joe Zhou',
    organization: "China Merchants Offshore",
  },
  //Posters
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Besson_Ifremer_053019.pdf?alt=media&token=cf6c8465-6ae4-4499-8fbe-76f96c659802',
  localUrl:'',
  title:"Non-supervised classification of benthic habitats based on seafloor geomorphology in the French Exploration Contract for Polymetallic Nodules – Clarion-Clipperton Zone",
  author: 'Florian Besson, Sylvain Bermell-Fleury, Lénaick Menot, Ewan Pelleter',
  organization: "Ifremer – Centre de Bretagne Marine Geosciences Department",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Brekke_082719.pdf?alt=media&token=826eca01-9887-4775-b9d3-9261994af14b',
  localUrl:'',
  title:"Acquiring exploration data from polymetallic sulphides on the Mohns Ridge on the Norwegian continental shelf", 
  author: 'Jan Stenløkk, Harald Brekke (Presenter), Nils Rune Sandstå, Sissel Eriksen, Kristoffer Solvi, Andreas Bjørnestad', 
  organization: "Norwegian Petroleum Directorate",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Castle_CRP_052219.pdf?alt=media&token=f341acea-7510-4a3d-bada-5bdff2a88456',
  localUrl:'',
  title:"Chatham Rock Phosphate – an example of a sustainable development of seabed mineral resources while minimising the environmental impact and using ground breaking technology",
  author: 'C D Castle, R A Wood, R K H Falconer, CJ McKenzie, R Grogan ',
  organization: "Chatham Rock Phosphate Limited",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Chen_and_Ma_IDSSE_061419.pdf?alt=media&token=9187501e-b36a-4566-8f03-702bc733ce13',
  localUrl:'',
  title:"Preparation of Bonded Super-hydrophobic Thin Film",
  author: 'Chen Ming and Ma Haoxiang',
  organization: "Institute of Deep-sea Science and Engineering Chinese Academy of Sciences, Sanya, China",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Chi_091019.pdf?alt=media&token=2a07a488-0cc6-4372-95c1-9aa0644da956',
  localUrl:'',
  title:"Shipboard magnetic and rock-magnetic characterization of hydrothermal activities in the North Fiji basin",
  author: 'Sang-Bum Chi* , Jung-Keuk Kang, Youngtak Ko, Wonnyon Kim',
  organization: "Korea Institute of Ocean Science & Technology (KIOST) Marine Resources Research Division",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Feng_Shanghai_Oil_061819.pdf?alt=media&token=2ecc995e-3d11-4f8b-b2a6-985d17295c07',
  localUrl:'',
  title:"Seabed Mineral Resources Extraction-ICCP",
  author: 'Feng Guojing',
  organization: "Shanghai FB Oil Equipment Tech Co.,LTD",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Dong_HuazhongU_062219_JRH.pdf?alt=media&token=f21d9c0c-dafe-4f97-8027-90842ad68d42',
  localUrl:'',
  title:"Design and Implementation of Monitoring System for Deep Sea Cobalt-rich Crust Sampling Vehicle",
  author: 'Dong Donglei, Zheng Jinrong, Xiang Xianbo',
  organization: "School of Naval Architecture and Ocean Engineering, Huazhong University of Science and Technology",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Cho_KRISO_062319_JRH_km.pdf?alt=media&token=9e0e00aa-42fc-4365-be9e-188d20dc63be',
  localUrl:'',
  title:"An estimation study about the amount of collection in the pick-up device for the deep-sea mining system",
  author: 'Su-gil Cho, Jaewon Oh, Cheonghong Min, Hyungwoo Kim, and Sup Hong',
  organization: "Korea Research Institute of Ships & Ocean Engineering",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Firstova_VNIIO_062219_JRH.pdf?alt=media&token=83df3c52-0c0a-4102-bf30-f005c2519591',
  localUrl:'',
  title:"Low-grade ultramafic-hosted SMS deposits: Case study of the Pobeda hydrothermal field",
  author: 'Anna Firstova, Georgy Cherkashov, Victor Bel’tenev, Katerina Kuksa, Vladislav Kuznetsov',
  organization: "Institute for Geology and Mineral Resources of the Ocean FSBI “VNIIOkeangeologia",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Graber_GEOMAR_053119.pdf?alt=media&token=10d2a7a1-b0bc-41d2-b54b-ce9795753b4b',
  localUrl:'',
  title:"GIS - based approach to define permissive areas for SMS exploration along the slow-spreading MidAtlantic Ridge",
  author: 'Sebastian Graber, Sven Petersen, Meike Klischies, Mark Hannington GEOMAR- Helmholtz Centre for Ocean Research Kiel',
  organization: "Marine Mineral Resources",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Helmons_Rock_TU-Delft_061619.pdf?alt=media&token=afdd9753-1821-49ef-a93c-e1b5bd9172a6',
  localUrl:'',
  title:"A 3D method to dynamically model the cutting ofsubmerged rocks with evaluation of pore pressure effects",
  author: 'Rudy Helmons and Cees van Rhee',
  organization: "Delft University of Technology",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_HuY_XianIO_060619.pdf?alt=media&token=ee0a3e85-2291-4b40-986a-452440c13cdb',
  localUrl:'',
  title:"Design of Oval Plane Mirror Component in Marine Remote Sensing Satellite for Mineral Resources",
  author: 'Hu Yongming, Chai Wenyi, Song Yang, Wang Chenjie, Xu Yang',
  organization: "Xi’an Institute of Optics and Precision Mechanics of Chinese Academy of Sciences",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Konstantinova_VNIIO_053119.pdf?alt=media&token=73db2225-6095-4055-b72d-9e9702d48d3e',
  localUrl:'',
  title:"Mineral associations in the crusts from Mendeleev Ridge based on SEM-EDS and microprobe analyses",
  author: 'Natalia Konstantinova, James R. Hein, Georgy Cherkashov',
  organization: "I. S. Gramberg Institute for Geology and Mineral Resources of the Ocean St. Petersburg, Russia ",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Kozlowska_PGI_070819_AKR.pdf?alt=media&token=19d1004c-df22-44e3-a240-5064f5a5f122',
  localUrl:'',
  title:"Characteristics of the Polish contract area in the Mid-Atlantic Ridge",
  author: 'Agata Kozłowska-Roman1*, Michał Tomczak, Artur Skowronek',
  organization: "Polish Geological Institute - National Research Institute",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Kurras_SFI_060919.pdf?alt=media&token=822a5383-a719-4707-b8d6-f0f744230c17',
  localUrl:'',
  title:"Assessment of polymetallic nodule resources using high-resolution AUV based geophysical imagery, near-bottom photographs and seabed boxcore sampling.",
  author: 'Gregory J Kurras',
  organization: "Seafloor Investigations LLC",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Kwan_HKUST_052719.pdf?alt=media&token=77d96699-f24c-4ef3-84a2-aff59d2549bc',
  localUrl:'',
  title:"In situ Biomarker Discovery in Deep-sea Amphipods for Deep-sea Mining activities using TMT-based Comparative Proteomics",
  author: 'Kwan Yick Hang , Sun Jin , Zhang Dongsheng , Nélia C. Mestre , Qian Pei-Yuan',
  organization: "Department of Ocean Science, Hong Kong University of Science and Technology, Hong Kong, China, Second Institute of Oceanography, Ministry of Natural Resources, Hangzhou, China, CIMA - Centro de Investigação Marinha e Ambiental, Universidade do Algarve, Campus de Gambelas, 8005-139, Faro, Portugal",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Lu_JiangsuU_053019_km.pdf?alt=media&token=e11025c6-87dc-4e69-811f-d6012f0e1432',
  localUrl:'',
  title:"Deep-sea mining equipment research at the Marine Equipment and Technology Institute of Jiangsu University of Science and Technology",
  author: 'Lu Daohua, Liu Gang, Guo Hao, Wu Baigong, Xu Jing,Tang Yanbing',
  organization: "Jiangsu University of Science and Technology Marine Equipment and Technology Institute",
  }
  ,
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Liu_Zhou_Changsha_051119.pdf?alt=media&token=4455908d-1d44-449b-828c-c646f674ccdb',
  localUrl:'',
  title:"Research on Shipborne Dewatering Process Technology in Deep-sea Sulfide Mine",
  author: 'Liu Shimei and Zhou Yueyuan',
  organization: "Changsha Research Institute of Mining and Metallurgy Sub-institute of Mining and Metallurgy Equipment",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Lim_2Hoffshore_062419.pdf?alt=media&token=2e5b7ad4-59a1-432e-a848-a70b9e19afee',
  localUrl:'',
  title:"A Non-Metallic Riser Concept for the Ultra-Deep Seabed Mining Vertical Transport System",
  author: 'Frank Lim',
  organization: "2H Offshore",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Oh_KRISO_Rev_062219_JRH.pdf?alt=media&token=8efa962a-3e97-4d53-b274-224c3b16b063',
  localUrl:'',
  title:"A study on the simulation-based design technology of the subsea equipment using DIMS toolkit",
  author: 'Jaewon Oh, Hyungwoo Kim, Sup Hong, Sugil Cho, Cheonhong Min',
  organization: "Korea Research Institute of Ships & Ocean engineering (KRISO)",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Min_KRISO_052819.pdf?alt=media&token=91f52a6e-c4e8-4765-b744-e42d1c14ded5',
  localUrl:'',
  title:"A review of the structural health monitoring for marine risers/pipes ",
  author: 'Cheonhong Min, Hyungwoo Kim, Sugil Cho, Jaewon Oh and Sup Hong',
  organization: "Korea Research Institute of Ships & Ocean engineering (KRISO)",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Mikhailik_FEGI_062319_JRH_km.pdf?alt=media&token=e5d24a31-12d7-4ccb-95f5-66ba75821781',
  localUrl:'',
  title:"Titanium Concentration in the Mineral Phases of Ferromanganese Deposits from the N-W Pacific",
  author: 'P.E. Mikhailik, A.I. Khanchuk, E.V. Mikhailik',
  organization: "Far East Geological Institute, FEB RAS",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_McKenzie_RSC_060319.pdf?alt=media&token=ea80098b-34db-43fa-ad99-5332923f9e7e',
  localUrl:'',
  title:"Determining and communicating marine mineral resource estimates to the broader minerals industry",
  author: 'Sean Aldrich, Campbell McKenzie (Presenter), René Sterk',
  organization: "RSC Mining & Mineral Exploration Limited",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Willaert_Ghent_090519.pdf?alt=media&token=33d915b2-41cc-4178-8c3d-c137e0108f9c',
  localUrl:'',
  title:"Transparency, public participation and access to justice in the context of deep sea mining: luxury or legal obligation?",
  author: 'Dr. Klaas Willaert',
  organization: "Ghent University Faculty of Law and Criminology – Department of European, Public and International Law – Maritime Insititute",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Wang_SIO_062319_JRH_km.pdf?alt=media&token=8c59c703-ae59-4b8c-a667-345485602c3c',
  localUrl:'',
  title:"Copper-rich disseminated sulfides near a transform fault on the southern Carlsberg Ridge: Implications for off-axis seafloor massive sulfide mineralization",
  author: 'Wang Yejian, Han Xiqiu, Li Honglin, Peng Zhou Peng, Dong Chuanqi, Qiu Zhongyan, Yu Xing, Liu Jiqiang',
  organization: "Key Laboratory of Submarine Geosciences Second Institute of Oceanography, Ministry of Natural Resources",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Sukhanova_VNIIO_061419.pdf?alt=media&token=a7e394de-a9c1-4911-98c5-65336d88071c',
  localUrl:'',
  title:"Uranium in seafloor massive sulfides at the MidAtlantic Ridge",
  author: 'Anna Sukhanova, Anna Firstova, Tamara Stepanova, Georgy Cherkashov',
  organization: "Institute for Geology and Mineral Resources of the Ocean FSBI “VNIIOkeangeologia“",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Ren_FIO_052819.pdf?alt=media&token=90d280fe-f121-4f25-9217-64acc20a8050',
  localUrl:'',
  title:"A preliminary study on the geological continuity of polymetallic nodules in the deep-sea basin between guyots Suda and Scripps of the western Pacific based on coverage from Towed Camera Sledge", 
  author: 'Ren Xiangwen',
  organization: "First Institute of Oceanography, Ministry of Natural Resources of the People’s Republic of China",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Xiong-Chen_IDSSE_061419.pdf?alt=media&token=118c8dbb-c182-4fbf-8b2c-261c385b2dcc',
  localUrl:'',
  title:"Numerical Study on Settling and Floating Movements of a Sphere Particle Flowing in a Vertical Pipe",
  author: 'Chen Yuxiang and Xiong Hong (Presenter)',
  organization: "Institute of Deep-sea Science and Engineering Chinese Academy of Sciences, Sanya, China Department of Deep-sea Technology and Engineering",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Yamazaki_OsakuU_052319.pdf?alt=media&token=b1cff878-80a3-4fb2-85c0-938d6fb04ef8',
  localUrl:'',
  title:"Feasibility study of combined mining of rare-earth element rich mud and manganese nodules by pulplift in Japan’s EEZ",
  author: 'T. Yamazaki, K. Hayashi, N. Nakatani, R. Arai',
  organization: "Osaka Prefecture University Graduate School of Engineering",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_YooCM-KimHJ_KIOST_052919.pdf?alt=media&token=d77d2bd4-8d46-474e-8a1b-16cc0a6d128b',
  localUrl:'',
  title:"CO2 outgassing suppressed by enhanced biological pump in the Eastern Tropical Pacific",
  author: 'Hyung Jeek Kim, Chan Min Yoo (Presenter), and Sang Bum Chi',
  organization: "Korea Institute of Ocean Science & Technology Deep-sea and Seabed Mineral Resources Research Center",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Zhang_GP_CSU_053019.pdf?alt=media&token=d4f83397-03ab-49b6-a85d-92da737a603f',
  localUrl:'',
  title:"Visual Simulation of Deep-Sea Mining System",
  author: 'Zhang Gui-ping, Hu Qiong',
  organization: "Central South University College of Mechanical and Electrical Engineering，",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_ZhuoX_Minmetals_20190829.pdf?alt=media&token=27b871a3-501a-4a6f-8d36-a475f3921321',
  localUrl:'',
  title:"Current Situation and Prospect of Technological Development in Deep Sea Mining by China Minmetals Corporation",
  author: 'Zhuo Xiaojun',
  organization: "Minmetals Corporation",
  },
  {
  downloadUrl:'https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Liu_Feng_Poster_Abstract.pdf?alt=media&token=216ae0ae-baa4-48cb-9264-18e403928189',
  localUrl:'',
  title:"State Practices of China in the Area",
  author: 'Liu Feng',
  organization: "China Ocean Mineral Resources R&D Association Beijing, China",
  }
  // ,
  // {
  // downloadUrl:'',
  // localUrl:'',
  //title:"",
  // author: '',
  // organization: "",
  // },
  


]

  displayedList = [];

  loading: any;


  secretPassword = "umc2019";
  passwordInput = "";
  viewingPDF = "";
  currentAbstract: any;

  pdfURL:SafeUrl = "";
  

  baseUrl = "https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/";
  searchTerm = "";

  constructor(private documentViewer: DocumentViewer,
              private file: File,
              private fileOpener: FileOpener,
              private ft: FileTransfer,
              private navCtrl: NavController,
              private loadingCtrl: LoadingController,
              private menuCtrl: MenuController,
              public gsc: GscService
              ) { 
                this.menuCtrl.enable(false);
  }

  ngOnInit() {

    this.conferenceAbstracts.sort((a,b) =>{  if(a.title < b.title) { return -1; }
    if(a.title > b.title) { return 1; }})

    this.displayedList = this.conferenceAbstracts;
  }
  // getImgContent(): SafeUrl {
  //   return this.sanitizer.sanitize(SecurityContext.URL,"https://firebasestorage.googleapis.com/v0/b/unwater-mining-conference.appspot.com/o/Final_POSTER_Helmons_Rock_TU-Delft_061619.pdf?alt=media&token=afdd9753-1821-49ef-a93c-e1b5bd9172a6");
  // }
  openAbstract(abstract){

    this.showAbstract(abstract);
  
  }
  goHome(){
    this.navCtrl.navigateRoot('/home');
  }
  showAbstract(abstract){
    window.open(abstract.downloadUrl,'_system', 'location=yes, titlebar=no');
  }
  async downloadAbstract(abstract){
    window.open(abstract.downloadUrl,'_system', 'location=yes, titlebar=no');
  }
  enterPassword(){
    console.log(this.passwordInput);
  
    if(this.passwordInput == this.secretPassword){
      this.gsc.accessGranted = true;
      
    }
  }
  sbSearchResponse(){
    if(this.searchTerm.length > 1 && this.gsc.accessGranted){
      let copy = this.conferenceAbstracts.slice();
      this.displayedList = copy.filter(item => {
        let termLC = this.searchTerm.toLowerCase();
        let match = item.title.toLowerCase().startsWith(termLC);
        if(!match) match = item.title.toLowerCase().includes(termLC);
        if(!match) match = item.author.toLowerCase().startsWith(termLC);
        if(!match) match = item.author.toLowerCase().includes(termLC);
        if(!match) match = item.organization.toLowerCase().includes(termLC);
        if(!match) match = item.organization.toLowerCase().startsWith(termLC);

        return match;
      })
    }else{
      this.displayedList = this.conferenceAbstracts;
    }
  }
  openLocalPDF(abstract) {
    let withoutBaseUrl = abstract.downloadUrl.replace(this.baseUrl, '');
    let brokenString = withoutBaseUrl.split('?alt');;
    this.gsc.PDFOfInterestPath = 'assets/abstracts/'+brokenString[0];
    this.navCtrl.navigateForward('/local-pdf-view');
  }
  
}
